export const base_path ='.'
export const img_path ='./'
//export const API_BASE_PATH ='https://crm-dev.iatsolutions.co:7776'  
//export const API_BASE_PATH ='https://crm-demo.iatsolutions.co:7779'
//export const API_BASE_PATH ='https://crm-test.iatsolutions.co:7778'
//export const API_BASE_PATH ='http://127.0.0.1:8000'
export const API_BASE_PATH ='https://api.crm.royaltechsystems.co.in/'  